import { NavLink, useLocation } from 'react-router-dom'
import { useAuth } from '../lib/auth'

export function MobileTabBar() {
  const { user, openLoginModal } = useAuth()
  const location = useLocation()
  const isEmployer = (user?.companies.length ?? 0) > 0

  const handleAccountClick = (e: React.MouseEvent) => {
    if (!user) {
      e.preventDefault()
      openLoginModal()
    }
  }

  // Active check helper
  const isHomeActive = location.pathname === '/'
  const isJobsActive = location.pathname.startsWith('/jobs')
  const isFreshersActive = location.pathname.startsWith('/freshers')
  const isDashboardActive = location.pathname.startsWith('/candidate') || location.pathname.startsWith('/applications') || location.pathname.startsWith('/employer') || location.pathname.startsWith('/assessments')
  const isAccountActive = location.pathname === '/login' || location.pathname === '/register' || location.pathname.startsWith('/candidate/profile')

  if (location.pathname.startsWith('/employer')) return null

  return (
    <nav className="mobile-tab-bar" aria-label="Mobile Bottom Navigation">
      <div className="mobile-tab-bar-inner">
        {/* 1. Home */}
        <NavLink
          to="/"
          end
          className={`mobile-tab-item ${isHomeActive ? 'active' : ''}`}
          aria-label="Home"
        >
          <div className="mobile-tab-icon-wrap">
            <svg className="mobile-tab-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
              <polyline points="9 22 9 12 15 12 15 22" />
            </svg>
          </div>
          <span className="mobile-tab-label">Home</span>
        </NavLink>

        {/* 2. Search Jobs */}
        <NavLink
          to="/jobs"
          className={`mobile-tab-item ${isJobsActive ? 'active' : ''}`}
          aria-label="Jobs"
        >
          <div className="mobile-tab-icon-wrap">
            <svg className="mobile-tab-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="11" cy="11" r="8" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
          </div>
          <span className="mobile-tab-label">Jobs</span>
        </NavLink>

        {/* 3. Freshers Hub (Special Feature Center Tab) */}
        <NavLink
          to="/freshers"
          className={`mobile-tab-item ${isFreshersActive ? 'active' : ''}`}
          aria-label="Fresher Hub"
        >
          <div className="mobile-tab-icon-wrap">
            <svg className="mobile-tab-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M22 10v6M2 10l10-5 10 5-10 5z" />
              <path d="M6 12v5c3 3 9 3 12 0v-5" />
            </svg>
          </div>
          <span className="mobile-tab-label">Freshers</span>
        </NavLink>

        {/* 4. Applications / Dashboard / Assessments */}
        {user ? (
          isEmployer ? (
            <NavLink
              to="/employer"
              className={`mobile-tab-item ${isDashboardActive ? 'active' : ''}`}
              aria-label="Employer Console"
            >
              <div className="mobile-tab-icon-wrap">
                <svg className="mobile-tab-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect width="20" height="14" x="2" y="7" rx="2" ry="2" />
                  <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
                </svg>
              </div>
              <span className="mobile-tab-label">Console</span>
            </NavLink>
          ) : (
            <NavLink
              to="/applications"
              className={`mobile-tab-item ${isDashboardActive ? 'active' : ''}`}
              aria-label="My Applications"
            >
              <div className="mobile-tab-icon-wrap">
                <svg className="mobile-tab-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
                  <polyline points="14 2 14 8 20 8" />
                  <line x1="16" y1="13" x2="8" y2="13" />
                  <line x1="16" y1="17" x2="8" y2="17" />
                  <line x1="10" y1="9" x2="8" y2="9" />
                </svg>
              </div>
              <span className="mobile-tab-label">Applied</span>
            </NavLink>
          )
        ) : (
          <NavLink
            to="/assessments"
            className={`mobile-tab-item ${location.pathname.startsWith('/assessments') ? 'active' : ''}`}
            aria-label="Skill Tests"
          >
            <div className="mobile-tab-icon-wrap">
              <svg className="mobile-tab-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="m9 11 3 3L22 4" />
                <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" />
              </svg>
            </div>
            <span className="mobile-tab-label">Tests</span>
          </NavLink>
        )}

        {/* Menu / Account */}
        {user ? (
          <NavLink
            to="/candidate/profile"
            className={`mobile-tab-item ${isAccountActive ? 'active' : ''}`}
            aria-label="Profile"
          >
            <div className="mobile-tab-icon-wrap">
              <span className="mobile-tab-avatar">
                {user.first_name ? user.first_name[0]?.toUpperCase() : 'U'}
              </span>
            </div>
            <span className="mobile-tab-label">Profile</span>
          </NavLink>
        ) : (
          <button
            type="button"
            className="mobile-tab-item mobile-tab-btn"
            onClick={handleAccountClick}
            aria-label="Sign In"
          >
            <div className="mobile-tab-icon-wrap">
              <svg className="mobile-tab-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
                <circle cx="12" cy="7" r="4" />
              </svg>
            </div>
            <span className="mobile-tab-label">Sign In</span>
          </button>
        )}
      </div>
    </nav>
  )
}
